import axios from 'axios';

export const downloadOtherReports = (projectId, params) => axios.get(`/projects/${projectId}/visits/export`, { params });

export default {
  downloadOtherReports
};
